import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../../mensajes2';
import { Dimmer } from '../../spinner';
import moment from 'moment';

export const ImpDeudaGeneralActiEco = (props) => {
    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [ tipoContribuyente, setTipoContribuyente] = useState('');
   
    const [report, setReport] = useState('');
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtCredito = useRef();
    const txtEjecucion = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();
    const txtTipoContribuyente = useRef();
    const txtOrdenarPor = useRef();
    const txtDeudaDesdeAnio = useRef();
    const chkMostrarPagos = useRef();
    const chkActivo = useRef();
    const chkInactivo = useRef();
    const chkClausurado = useRef();
    const chkFiscal = useRef();
    const chkNotificado = useRef();
    const chkDepLegal = useRef();
    const chkExonerado = useRef();
    const chkRevCerrado = useRef();
    const radGeneral = useRef();
    const radDetallado = useRef();
    const radDetalladoMensual = useRef();

    const [tipoReporte, setTipoReporte] = useState('');
    const [deudaDesdeAnio, setDeudaDesdeAnio] = useState({
        Activo: false,
        Inactivo: false,
        Clausurado: false,
        Fiscal: false,
        Notificado: false,
        DepLegal: false,
        Exonerado: false,
        RevCerrado: false
    });

    console.log(tipoReporte)
    const onChangeValidar = (e) => {
        e.preventDefault();
        // Aquí puedes usar las referencias para acceder a los valores de los inputs, checkboxes y radios
        console.log("Tipo de Contribuyente:", txtTipoContribuyente.current.value);
        console.log("Ordenar por:", txtOrdenarPor.current.value);
        console.log("Deuda desde el Año:", txtDeudaDesdeAnio.current.value);
        console.log("Mostrar Pagos:", chkMostrarPagos.current.checked);
        console.log("Tipo de Reporte:", tipoReporte);
        console.log("Deuda desde el Año (Checkboxes):", deudaDesdeAnio);
    };

    const onChange = (e) => {

        if(e.target.id = 'tipoContribuyente'){
            setTipoContribuyente(e.target.value)
        }
       
    };

    const onCheck = (e) => {
        if (e.target.id === 'credito') {
            setReport('Pres_IngrEdoEjecCredi');
            setActivo(false);
        } else if (e.target.id === 'ejecucion') {
            if (espiritu === 0) {
                setReport('Pres_IngrEdoEjecOrd1');
            } else {
                setReport('Pres_IngrEdoEjecOrd');
            }
            setActivo(false);
        } else if (e.target.name === 'tipoReporte') {
            setTipoReporte(e.target.value);
        } else if (e.target.name === 'deudaDesdeAnio') {
            setDeudaDesdeAnio({
                ...deudaDesdeAnio,
                [e.target.value]: e.target.checked
            });
        }
    };

    const imprimirEstadoFinancieroPresupuesto = (desde, hasta) => {
        var reporte = report;
        let desdec = "'" + moment.utc(desde).format('DD-MM-YYYY') + "'";
        let hastac = "'" + moment.utc(hasta).format('DD-MM-YYYY') + "'";
        let dia = hasta.substring(8, 10);
        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + dia + "&sql3=" + desdec + "&sql4=" + hastac, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    };

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    };

    const blanquear = () => {
        txtTipoContribuyente.current.value = '';

        txtOrdenarPor.current ? txtOrdenarPor.current.value = '' : '';
        txtDeudaDesdeAnio.current.value = '';
        chkMostrarPagos.current ?  chkMostrarPagos.current.checked = false : '';
        setActivo(true);
        setTipoReporte('General');
        setDeudaDesdeAnio({
            Activo: false,
            Inactivo: false,
            Clausurado: false,
            Fiscal: false,
            Notificado: false,
            DepLegal: false,
            Exonerado: false,
            RevCerrado: false
        });
    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    };


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                setHasta(fech);
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'>Impresion General de Contribuyentes con Deudas por Periodo.</div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Dimmer active={activate} inverted></Dimmer>

                <div className="col-md-12 row mx-auto px-0">
                    <fieldset className="row border-azul rounded mx-auto mb-1">
                        <legend className="float-none m-0 w-auto">Tipo de Contribuyente</legend>
                        <div className='col-sm-12 mb-1 px-1 ml-auto'>
                            <div className="input-group input-group-sm m-0 w-100">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Tipo de Contribuyente:</label>
                                <select
                                    className="form-select text-uppercase"
                                    onChange={onChange}
                                    ref={txtTipoContribuyente}
                                    id="tipoContribuyente"
                                >
                                    <option value="">Seleccione...</option>
                                    <option value="0">Todos</option>
                                    <option value="1">Tipo de Contribuyente</option>
                                    <option value="2">Historico Anual</option>
                                    <option value="3">Declararon/Retenciones</option>
                                </select>
                            </div>
                        </div>
                    </fieldset>

                    {tipoContribuyente !== "1" ? 
                        <div className="row border-azul py-1 rounded col-md-6 px-1 mx-auto mb-1">
                            <label className="fw-bold col my-auto py-0">Fecha de la Deuda</label>
                            <div className="input-group input-group-sm my-auto col-md-7 px-0">
                                <label className="input-group-text" id="inputGroup-sizing-sm">
                                    Al Día:
                                </label>
                                <input
                                    type="date"
                                    className="form-control text-uppercase"
                                    aria-label="Sizing example input"
                                    aria-describedby="inputGroup-sizing-sm"
                                    id="declararonRetenciones"
                                />
                            </div>
                        </div>
                    : ''}


                    <div className='row m-0 px-0 mb-2 border-azul rounded py-2 mb-1 '>
                        <label className="fw-bold col my-auto ">Tipo de Reporte</label>
                        <div className="form-check col ml-auto">
                            <input className="form-check-input my-auto" type="radio"  name="tipoReporte" id="tipoReporteGeneral" value="0" checked={tipoReporte === '0'} onChange={onCheck} ref={radGeneral} />
                            <label className="form-check-label my-auto" htmlFor="tipoReporteGeneral">
                                General
                            </label>
                        </div>
                        <div className="form-check col ml-auto">
                            <input className="form-check-input my-auto" type="radio" name="tipoReporte" id="tipoReporteDetallado" value="1" checked={tipoReporte === '1'} onChange={onCheck} ref={radDetallado} />
                            <label className="form-check-label my-auto" htmlFor="tipoReporteDetallado">
                                Detallado
                            </label>
                        </div>
                        <div className="form-check col ml-auto">
                            <input className="form-check-input my-auto" type="radio" name="tipoReporte" id="tipoReporteDetalladoMensual" value="2" checked={tipoReporte === '2'} onChange={onCheck} ref={radDetalladoMensual} />
                            <label className="form-check-label my-auto" htmlFor="tipoReporteDetalladoMensual">
                                Detallado Mensual
                            </label>
                        </div>
                       { tipoReporte.toString() === '2' ? <div className="form-check col">
                            <input className="form-check-input my-auto" type="checkbox" ref={chkMostrarPagos} id="flexCheckDefault" />
                            <label className="form-check-label my-auto" htmlFor="flexCheckDefault">
                                Mostrar Pagos
                            </label>
                        </div> : ''}
                    </div>

                    {tipoContribuyente === "1" ? <div className="input-group input-group-sm col-md-8 mb-1 pl-0">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Ordenar por:</label>
                        <select
                            className="form-select text-uppercase"
                            onChange={onChange}
                            ref={txtOrdenarPor}
                            id="tipoContribuyente"
                        >
                            <option value="">Seleccione...</option>
                            <option value="PERMANENTE">PERMANENTE</option>
                            <option value="TRANSEUNTE">TRANSEUNTE</option>
                            <option value="EVENTUAL O AMBULANTE">EVENTUAL O AMBULANTE</option>
                            <option value="IRREGULAR">IRREGULAR</option>
                            <option value="REVISADO/CERRADO">REVISADO/CERRADO</option>
                            <option value="TODOS">TODOS</option>
                        </select>
                    </div> : ''}

                    <div className="input-group input-group-sm col-md-4 mr-0 px-0 mb-1">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Deuda desde el Año:</label>
                        <input type="text" className="form-control text-uppercase" onChange={onChange} ref={txtDeudaDesdeAnio} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="declararonRetenciones" />
                    </div>

                    <div className='row m-0 px-0 mb-2 border-azul rounded py-2'>
                        <div className='col-md-3 my-auto'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioActivo" value="Activo" checked={deudaDesdeAnio.Activo} onChange={onCheck} ref={chkActivo} />
                                <label className="form-check-label" htmlFor="deudaDesdeAnioActivo">
                                    Activo
                                </label>
                            </div>
                        </div>
                        <div className='col-md-3 my-auto'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioInactivo" value="Inactivo" checked={deudaDesdeAnio.Inactivo} onChange={onCheck} ref={chkInactivo} />
                                <label className="form-check-label" htmlFor="deudaDesdeAnioInactivo">
                                    Inactivo
                                </label>
                            </div>
                        </div>
                        <div className='col-md-3 my-auto'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioClausurado" value="Clausurado" checked={deudaDesdeAnio.Clausurado} onChange={onCheck} ref={chkClausurado} />
                                <label className="form-check-label" htmlFor="deudaDesdeAnioClausurado">
                                    Clausurado
                                </label>
                            </div>
                        </div>
                        <div className='col-md-3 my-auto'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioFiscal" value="Fiscal" checked={deudaDesdeAnio.Fiscal} onChange={onCheck} ref={chkFiscal} />
                                <label className="form-check-label" htmlFor="deudaDesdeAnioFiscal">
                                    Fiscal
                                </label>
                            </div>
                        </div>

                        <div className='col-md-3 my-auto'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioNotificado" value="Notificado" checked={deudaDesdeAnio.Notificado} onChange={onCheck} ref={chkNotificado} />
                                <label className="form-check-label" htmlFor="deudaDesdeAnioNotificado">
                                    Notificado
                                </label>
                            </div>
                        </div>
                        <div className='col-md-3 my-auto'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioDepLegal" value="DepLegal" checked={deudaDesdeAnio.DepLegal} onChange={onCheck} ref={chkDepLegal} />
                                <label className="form-check-label" htmlFor="deudaDesdeAnioDepLegal">
                                    Dep. Legal
                                </label>
                            </div>
                        </div>
                        <div className='col-md-3 my-auto'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioExonerado" value="Exonerado" checked={deudaDesdeAnio.Exonerado} onChange={onCheck} ref={chkExonerado} />
                                <label className="form-check-label" htmlFor="deudaDesdeAnioExonerado">
                                    Exonerado
                                </label>
                            </div>
                        </div>
                        <div className='col-md-3 my-auto'>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="deudaDesdeAnio" id="deudaDesdeAnioRevCerrado" value="RevCerrado" checked={deudaDesdeAnio.RevCerrado} onChange={onCheck} ref={chkRevCerrado} />
                                <label className="form-check-label" htmlFor="deudaDesdeAnioRevCerrado">
                                    Rev/Cerrado
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>
    );
};